import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  List,
  TextField,
  EditButton,
  Datagrid,
  ReferenceField,
  TextInput,
  ReferenceInput,
  SelectInput,
  SimpleList,
  ShowButton,
  TopToolbar,
  CreateButton,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { DEPARTMENTS, MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { AdministrationExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";
import { administrationRequests } from "api/administrationApi";

const departmentFilters = [
  <TextInput
    label="Име на български език"
    source="nameBg"
    style={{ width: 375 }}
    alwaysOn
  />,
  <ReferenceInput
    source="structuralUnitId"
    reference={administrationRequests.getStructuralUnitsSelect()}
    label="Структурна единица"
    style={{ width: 375 }}
    alwaysOn
  >
    <SelectInput
      label="Структурна единица"
      emptyText="Всички"
      style={{ width: 375 }}
    />
  </ReferenceInput>,
];

const ListDepartments = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const UserPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={AdministrationExporter(DEPARTMENTS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Катедри"
      filters={departmentFilters}
      actions={<ListActions hasCreate={checkPermission(UserPermissions, permissions.canCreateDepartments)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Структурна единица",
                    value: (
                      <ReferenceField
                        source="structuralUnitId"
                        reference={administrationRequests.getStructuralUnitsSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateDepartments}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewDepartments}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <ReferenceField
            label="Структурна единица"
            source="structuralUnitId"
            reference={administrationRequests.getStructuralUnitsSelect()}
          >
            <TextField
              textAlign="center"
              source="name"
              label="Структурна единица"
            />
          </ReferenceField>
          <SecuredComponent permission={permissions.canUpdateDepartments}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewDepartments}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};
export default ListDepartments;
